"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;
var React = _interopRequireWildcard(require("react"));
var _componentUtils = require("../../common/componentUtils");
var _gemUrlFormatUtils = require("../../common/utils/domain/gemUrlFormatUtils");
require("../../common/style.scss");
var _reportUtil = require("../../utils/reportUtil");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
/**
 * Created By Gems CLI
 * Issues and merge requests are welcomed：https://git.woa.com/hulk/gems
 *
 * API 参考：
 * http://gems.woa.com/?path=/docs/%E5%BC%80%E5%8F%91-%E4%B8%9A%E5%8A%A1%E7%B4%A0%E6%9D%90%E5%BA%93-%E7%BC%96%E5%86%99%E7%BB%84%E4%BB%B6--page
 */

const _require = require('@tencent/cms-design-component'),
  ImCodeComponent = _require.ImCodeComponent;
function _default({
  componentKey,
  // {number} 用于标识每一个组件实例的全局唯一且持久化的 key
  data,
  // {object} “数据”表单内容
  style,
  // {object} “样式”表单内容
  commonStyle,
  // {object} “组件自定义样式”表单内容
  global,
  // {object} 页面容器自定义的全局配置项
  meta,
  // {object} 页面元数据
  componentsMap,
  // {Map<number, HTMLElement>} 所有组件 DOM 节点的 Map，key 为组件的 key（number）
  getComponentByKey,
  // {(key: number) => HTMLElement | undefined} 通过组件 key 获取组件 DOM 节点的 API
  store,
  // {object} 组件状态
  on,
  // {(event: string, callback: Function) => void} 事件触发调用
  emit,
  // {(event: string) => void | Promise<void>} 监听事件
  domains: domainInfos
}) {
  const domains = (0, _gemUrlFormatUtils.useDomainGems)({
    domainInfos
  });
  const _getFormatUrlMethods = (0, _gemUrlFormatUtils.getFormatUrlMethods)({
      domains
    }),
    formatUrlString = _getFormatUrlMethods.formatUrlString;
  if (Object.keys(data).length > 1) {
    const _ref = data,
      modTitle = _ref.modTitle,
      color = _ref.color,
      desc = _ref.desc,
      title = _ref.title,
      hrefBase = _ref.href,
      configuration = _ref.configuration,
      _ref$lightTheme = _ref.lightTheme,
      lightTheme = _ref$lightTheme === void 0 ? false : _ref$lightTheme,
      copySuccessTip = _ref.copySuccessTip,
      copyText = _ref.copyText,
      cardConfig = _ref.cardConfig,
      layout = _ref.layout;
    const href = formatUrlString(hrefBase);
    const bgStyle = color ? (0, _componentUtils.doComponentsBgColorEvent)(color) : {}; // 处理组件背景色
    const theme = lightTheme ? 'dark' : 'light';
    const mode = layout ? 'horizontal' : 'vertical';
    return /*#__PURE__*/React.createElement("div", Object.assign({
      id: modTitle
    }, (0, _reportUtil.reportShow)(['show_code', componentKey, modTitle])), /*#__PURE__*/React.createElement(ImCodeComponent, {
      theme: theme,
      layout: mode,
      title: modTitle,
      desc: desc,
      link: {
        txt: title,
        href,
        extendProps: {
          'report-event': 'click_code_href',
          'report-ext1': title,
          'report-ext2': href || ''
        }
      },
      configuration: configuration,
      style: bgStyle,
      copySuccessTip: copySuccessTip,
      copyText: copyText,
      cardConfig: cardConfig
    }));
  }
  return /*#__PURE__*/React.createElement("div", null);
}